import { createFileRoute } from "@tanstack/react-router";
import {
  parseReportingLandingTab,
  type ReportingLandingTab,
} from "@/components/portal/apps/reporting/landingTabs";
import { ReportingDashboard } from "@/components/portal/apps/reporting/ReportingDashboard";

export const Route = createFileRoute("/portal/apps/reporting/")({
  component: PortalReportingPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    groupAccess?: string;
    groupAccessName?: string;
    tab?: ReportingLandingTab;
  } => ({
    tab: parseReportingLandingTab(search.tab),
    groupAccess:
      typeof search.groupAccess === "string" && search.groupAccess.length > 0
        ? search.groupAccess
        : undefined,
    groupAccessName:
      typeof search.groupAccessName === "string" &&
      search.groupAccessName.length > 0
        ? search.groupAccessName
        : undefined,
  }),
});

function PortalReportingPage() {
  const { groupAccess, groupAccessName, tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ReportingDashboard
      initialGroupAccessReportId={groupAccess}
      initialGroupAccessReportName={groupAccessName}
      tab={tab}
      onTabChange={(next) =>
        navigate({ search: (prev) => ({ ...prev, tab: next }), replace: true })
      }
    />
  );
}
